export { default as adminLogin } from './adminLogin';
export { default as createProductCategory } from './createProductCategory';
export { default as updateProductCategory } from './updateProductCategory';
export { default as updateShippingMethod } from './updateShippingMethod';
export { default as updatePaymentMethod } from './updatePaymentMethod';
export { default as createBanner } from './createBanner';
export { default as updateBanner } from './updateBanner';
export { default as createProductListAd } from './createProductListAd';
export { default as updateProductListAd } from './updateProductListAd';
export { default as createCmsContent } from './createCmsContent';
export { default as updateCmsContent } from './updateCmsContent';
export { default as createProductAttributeOption } from './createProductAttributeOption';
export { default as updateProductAttributeOption } from './updateProductAttributeOption';
export { default as deleteProductAttributeOption } from './deleteProductAttributeOption';
export { default as updateProductAttribute } from './updateProductAttribute';
export { default as createProductAttribute } from './createProductAttribute';
export { default as deleteProductAttribute } from './deleteProductAttribute';
export { default as adminUpdateTimetableTimeSlot } from './adminUpdateTimetableTimeSlot';
export { default as createUrlAlias } from './createUrlAlias';
export { default as updateUrlAlias } from './updateUrlAlias';
export { default as deleteUrlAlias } from './deleteUrlAlias';
export { default as setAdminIpAddress } from './setAdminIpAddress';
export { default as updateUserPermissions } from './updateUserPermissions';
export { default as updateUser } from './updateUser';
export { default as grantAdminRightToUser } from './grantAdminRightToUser';
export { default as revokeAdminRightFromUser } from './revokeAdminRightFromUser';
export { default as adminUpdateProduct } from './adminUpdateProduct';
export { default as adminAddProductImages } from './adminAddProductImages';
export { default as adminDeleteProductImages } from './adminDeleteProductImages';
export { default as adminSortProductImages } from './adminSortProductImages';
export { default as adminUpdateProductMainImage } from './adminUpdateProductMainImage';
export { default as loginAsUser } from './loginAsUser';
export { default as createCoupon } from './createCoupon';
export { default as updateCoupon } from './updateCoupon';
export { default as createUserProductDiscount } from './createUserProductDiscount';
export { default as createUserShippingDiscount } from './createUserShippingDiscount';
export { default as updateUserShippingDiscount } from './updateUserShippingDiscount';
export { default as updateUserProductDiscount } from './updateUserProductDiscount';
export { default as enableBankTransferForBillingAddress } from './enableBankTransferForBillingAddress';
export { default as adminModifyOrder } from './adminModifyOrder';
export { default as createDonation } from './createDonation';
export { default as updateDonation } from './updateDonation';



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/index.ts